// Generated from design/system/tokens.json v1.5.1 by design/scripts/build_system_tokens.py.
// Do not edit; edit the JSON and rerun. The CSS custom properties in tokens.css are the runtime
// source; this file is for typed access to the same values and for the rules in $description.

export const tokens = {
  "$meta": {
    "name": "Brain Atlas design system",
    "version": "1.5.1",
    "status": "adopted",
    "date": "2026-10-02",
    "owner": "ba-look (design's owner since the 2026-10-02 handoff; the design lane before that)",
    "spec": "design/system/spec.md",
    "scope": "The app's UI (apps/atlas) and the engine's in-canvas HUD. The render look of anatomy (system colours, visibility states, lighting, materials, camera presets) stays in design/tokens.json; this file never repeats it.",
    "format": "W3C Design Tokens Community Group draft format: every leaf is an object with $type and $value, and may carry $description. Dimensions are CSS px at 1x (multiply by devicePixelRatio in the canvas). Durations are milliseconds. Colours are sRGB, as #RRGGBB or rgba().",
    "generated": [
      "design/system/tokens.css",
      "design/system/tokens.ts"
    ],
    "check": "python3 design/scripts/build_system_tokens.py --check",
    "rules": [
      "No research-use banner, no provenance badges or chips, no confidence copy anywhere on screen (AGENTS.md, startup mode). Provenance lives in pack and sim metadata and in the Methods panel.",
      "One accent, white. Links and keyboard focus are the only blue in the chrome.",
      "Numbers that can change are set in tabular figures. Units get a thin space: 12 mm, 3.5 s, 120 mmHg.",
      "Sentence case everywhere. The 11 px overline is the only uppercase text.",
      "Nothing in the chrome is smaller than 11 px at 1x."
    ],
    "notes": [
      "1.0.1 (2026-10-01): fitted to the app shell that merged in #151: floating top bar with scenario tabs (no rail), 288/328 panels, 60 px timeline, radius 14 on floating panels, Inter weights 430/530/620 on dark, a 64 px orientation gnomon without axis colours, scene identity colours, the command palette.",
      "1.1.0 (2026-10-01): the gaps the screens found. Generator: a reference to a type role emits its five sub-properties, a reference to a group fails the build, and the build fails on any var(--ba-…) the CSS doesn't define (23 broken uses in 1.0.2, 0 now). Callouts default to fewer: hud.budget rest 6, focus 12, max 24. New: size.dot, component.panel.section-head-height, size.swatch.md at 9, component.transport.tick, component.popover.offset, component.methods.caption.max-width, component.methods.sheet.label-width, component.slider.value-width, hud.label.height, type.palette-query, icon names reopen, flip and shortcuts. Corrected to spec 1.0.2: hud.label.padding, the Methods sheet's radius, padding and list, the transport clock, the panel's section gap, the tabs, the scale bar and time stamp positions, color.scrim at 45 %, font features without cv11, icon.size and icon.names.section.",
      "1.2.0 (2026-10-02): the gaps the six scenes' screens found (#460), all additive; nothing existing changes value. New: component.methods.caption-row (the Methods caption's row on the picture: 40 high where there is no timeline, the caption's box padded 4 × 6, 8 from Methods to the line), color.atmosphere.seizure (Seizure's violet haze, #1C1830), component.electrode-site (an EEG site: an 8 px disc with a 1 px ring in the canvas colour at 80 %, ivory #D9C9B4 at rest, the ictal amber #FFB347 with a 24 px halo at 55 % when the activity under it passes 0.3 to 0.6, pills 2 px clear), size.icon.xs (12, the checkbox's check), and icon.names checkbox (check) and wordmark (brain), which the fetch script carried outside the tokens until now. The screens' local --scr-caption-row, --scr-haze-seizure, --scr-electrode-rest and --scr-check-glyph become these tokens."
    ]
  },
  "color": {
    "canvas": {
      "$type": "color",
      "$value": "#0B0E13",
      "$description": "The page behind the viewport and the viewport's own clear colour. Matches background.scene.base in design/tokens.json so the chrome and the render share one black."
    },
    "surface": {
      "$description": "Opaque panel surfaces, darkest to lightest. One step up per level of nesting; never skip two.",
      "0": {
        "$type": "color",
        "$value": "#0B0E13"
      },
      "1": {
        "$type": "color",
        "$value": "#11151D"
      },
      "2": {
        "$type": "color",
        "$value": "#171C26"
      },
      "3": {
        "$type": "color",
        "$value": "#1F2531"
      },
      "4": {
        "$type": "color",
        "$value": "#283040"
      }
    },
    "surface-translucent": {
      "$description": "Surfaces that float over the viewport. Always paired with blur.panel so the render shows through as tone, not detail.",
      "panel": {
        "$type": "color",
        "$value": "rgba(17, 21, 29, 0.84)",
        "$description": "Left panel, inspector, transport bar, popovers."
      },
      "hud": {
        "$type": "color",
        "$value": "rgba(11, 14, 19, 0.78)",
        "$description": "Callout pills and section edge marks in the app's HUD overlay."
      },
      "sheet": {
        "$type": "color",
        "$value": "rgba(17, 21, 29, 0.96)",
        "$description": "The Methods sheet and dialogs: nearly opaque, because they carry reading text."
      },
      "topbar": {
        "$type": "color",
        "$value": "rgba(11, 14, 19, 0.88)",
        "$description": "Unused since 1.0.1: the top bar is a floating panel on surface-translucent.panel. Kept for the native build's bar."
      }
    },
    "text": {
      "primary": {
        "$type": "color",
        "$value": "#EEF2F7",
        "$description": "Names, values, body. Off-white, never pure white, so it doesn't glare beside the render."
      },
      "secondary": {
        "$type": "color",
        "$value": "#A7B0BE",
        "$description": "Second lines, units, meta."
      },
      "tertiary": {
        "$type": "color",
        "$value": "#6F7A8A",
        "$description": "Overlines, placeholders, hints."
      },
      "disabled": {
        "$type": "color",
        "$value": "#4C5563"
      },
      "inverse": {
        "$type": "color",
        "$value": "#0B0E13",
        "$description": "Text on the white accent."
      },
      "link": {
        "$type": "color",
        "$value": "#7CC4FF"
      }
    },
    "border": {
      "hairline": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.08)",
        "$description": "Panel edges, row separators."
      },
      "medium": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.14)",
        "$description": "Control outlines at rest."
      },
      "strong": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.24)",
        "$description": "Control outlines on hover; the active segment's edge."
      }
    },
    "accent": {
      "primary": {
        "$type": "color",
        "$value": "#FFFFFF",
        "$description": "Selection, primary buttons, the playhead, the active tab underline. White, so it reads the same beside every anatomy colour and matches the 3D selection outline."
      },
      "on-primary": {
        "$type": "color",
        "$value": "#0B0E13"
      },
      "focus": {
        "$type": "color",
        "$value": "#7CC4FF",
        "$description": "The keyboard focus ring. Blue so it stays visible on a white-selected control."
      }
    },
    "interactive": {
      "$description": "White overlays for control states. Applied over the surface the control sits on.",
      "hover": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.06)"
      },
      "pressed": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.10)"
      },
      "selected": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.12)",
        "$description": "A selected list row or segment: a quiet lift, plus 500 weight on its text."
      },
      "selected-strong": {
        "$type": "color",
        "$value": "#FFFFFF",
        "$description": "The one strong selection on screen: the primary button, the active scene."
      }
    },
    "feedback": {
      "info": {
        "$type": "color",
        "$value": "#7CC4FF"
      },
      "success": {
        "$type": "color",
        "$value": "#4FCF9A"
      },
      "warning": {
        "$type": "color",
        "$value": "#F5B544"
      },
      "danger": {
        "$type": "color",
        "$value": "#FF6B6B"
      }
    },
    "scrim": {
      "$type": "color",
      "$value": "rgba(0, 0, 0, 0.45)",
      "$description": "Black at 45 %, behind the command palette, sheets and dialogs."
    },
    "swatch-ring": {
      "$type": "color",
      "$value": "rgba(255, 255, 255, 0.18)",
      "$description": "A 1 px ring around colour swatches so dark colours keep an edge on dark surfaces."
    },
    "scene": {
      "$description": "Each scene's identity colour. Used in exactly three places: the dot on its tab, the dot before the panel title, and the timeline's played fill. Never on data, text or buttons.",
      "explore": {
        "$type": "color",
        "$value": "#7CC4FF"
      },
      "flow": {
        "$type": "color",
        "$value": "#FF5A5F"
      },
      "stroke": {
        "$type": "color",
        "$value": "#FFA14A"
      },
      "seizure": {
        "$type": "color",
        "$value": "#B18CFF"
      },
      "neurons": {
        "$type": "color",
        "$value": "#4FDCA4"
      },
      "drugs": {
        "$type": "color",
        "$value": "#FF7AC6"
      }
    },
    "atmosphere": {
      "$description": "Scene atmospheres from the colour scripts (design/art-direction/colour-scripts.md): the picture's darks are lifted toward the colour (lighten), most at the clear area's centre. Tone, not data and not wayfinding: never on chrome. Drugs lifts toward the occupancy scale's floor (scale.occupancy, stop 0); the other scenes have none.",
      "seizure": {
        "$type": "color",
        "$value": "#1C1830",
        "$description": "Seizure's violet haze, colour script 4's atmosphere (L* 10)."
      }
    }
  },
  "scale": {
    "$description": "Continuous colour scales for data, as five stops at positions 0, 0.25, 0.5, 0.75 and 1 in sRGB; interpolate in Oklab or linear sRGB, not in hue. Each scale is lightness-monotonic (sequential) or symmetric about a neutral centre (diverging), so it survives red-green deficiency. The domain is set per scene in its Methods metadata and shown on the colour bar. Anatomy keeps its system colours from design/tokens.json; these scales colour particles, overlays, traces and charts.",
    "velocity": {
      "$type": "gradient",
      "$description": "Blood velocity magnitude, slow to fast. Dark indigo through magenta to a warm near-white, so fast flow glows and slow flow recedes into the dark lumen.",
      "kind": "sequential",
      "$value": [
        {
          "position": 0.0,
          "color": "#1F1B4D"
        },
        {
          "position": 0.25,
          "color": "#6A2C8A"
        },
        {
          "position": 0.5,
          "color": "#C8456C"
        },
        {
          "position": 0.75,
          "color": "#FF8F3D"
        },
        {
          "position": 1.0,
          "color": "#FFF1B0"
        }
      ]
    },
    "pressure": {
      "$type": "gradient",
      "$description": "Pressure, low to high, diverging about the scene's reference pressure. Cool to warm; the centre is a neutral grey so 'normal' is colourless.",
      "kind": "diverging",
      "$value": [
        {
          "position": 0.0,
          "color": "#3C7DD9"
        },
        {
          "position": 0.25,
          "color": "#8FB3E6"
        },
        {
          "position": 0.5,
          "color": "#D9DEE6"
        },
        {
          "position": 0.75,
          "color": "#E8907A"
        },
        {
          "position": 1.0,
          "color": "#D1403A"
        }
      ]
    },
    "cbf": {
      "$type": "gradient",
      "$description": "Cerebral blood flow and other perfusion quantities as a quantity (charts, slice overlays), low to high. Near-black to ice white.",
      "kind": "sequential",
      "$value": [
        {
          "position": 0.0,
          "color": "#0B0E13"
        },
        {
          "position": 0.25,
          "color": "#1C3F6E"
        },
        {
          "position": 0.5,
          "color": "#2E86C1"
        },
        {
          "position": 0.75,
          "color": "#7BD3E6"
        },
        {
          "position": 1.0,
          "color": "#F4FBFF"
        }
      ]
    },
    "perfusion-deficit": {
      "$type": "gradient",
      "$description": "Perfusion deficit painted on tissue, none to critical. Starts at the cortex tissue colour (no change), warms through straw and amber, and ends in the deep crimson of infarct core. The same hues as scale.tissue-fate, so the continuous and the categorical views agree.",
      "kind": "sequential",
      "$value": [
        {
          "position": 0.0,
          "color": "#CCB7AD"
        },
        {
          "position": 0.25,
          "color": "#F3E7A1"
        },
        {
          "position": 0.5,
          "color": "#F5A623"
        },
        {
          "position": 0.75,
          "color": "#D9462F"
        },
        {
          "position": 1.0,
          "color": "#8E0F33"
        }
      ]
    },
    "tissue-fate": {
      "$type": "palette",
      "$description": "Stroke tissue state, categorical. 'healthy' means no overlay: the tissue keeps its own colour. Core is a dark crimson, well away from the artery red (#E63B3B) so a clot and the tissue it kills never share a hue.",
      "$value": {
        "healthy": null,
        "oligaemia": "#F3E7A1",
        "penumbra": "#F5A623",
        "core": "#B0143C",
        "reperfused": "#5EC8A0"
      }
    },
    "activity": {
      "$type": "gradient",
      "$description": "Neural activity: membrane potential, firing rate, seizure recruitment. Ember: rest is a dark violet that sits just above the background, firing climbs through red and amber to white.",
      "kind": "sequential",
      "$value": [
        {
          "position": 0.0,
          "color": "#171233"
        },
        {
          "position": 0.25,
          "color": "#4B2A7F"
        },
        {
          "position": 0.5,
          "color": "#C9452F"
        },
        {
          "position": 0.75,
          "color": "#FFB347"
        },
        {
          "position": 1.0,
          "color": "#FFFFFF"
        }
      ]
    },
    "sd": {
      "$type": "gradient",
      "$description": "Spreading depolarization on tissue: the depolarised fraction or wave amplitude, rest to crest. Cold, so a wave reads apart from seizure's ember and from the perfusion deficit's amber it crosses in Stroke: midnight at rest (no overlay), cobalt, azure, ice, white-ice at the crest. Not scale.cbf, a chart and slice scale that starts at the canvas colour and is greyer in the middle. The depression after the wave stays at the 0 stop. The engine adds emission for this scale (design/tokens.json overlays).",
      "kind": "sequential",
      "$value": [
        {
          "position": 0.0,
          "color": "#1A1F3A"
        },
        {
          "position": 0.25,
          "color": "#2B4C8C"
        },
        {
          "position": 0.5,
          "color": "#3F8FD6"
        },
        {
          "position": 0.75,
          "color": "#8FD3F4"
        },
        {
          "position": 1.0,
          "color": "#F0FAFF"
        }
      ]
    },
    "drive": {
      "$type": "gradient",
      "$description": "Stimulus drive on tissue, none to full: how strongly a stimulus reaches each point of the cortex (Mind's retinotopy sweep, sims/mind/benson14-vision, activity range 0-1; Stimulate's field magnitudes, TMS and tDCS |E| in V/m and focused-ultrasound pressure in MPa, over the run's own range; later the word, gene and decoding maps that are intensities, not firing). A field's network response is firing and takes scale.activity; a signed field component (E·n) takes scale.change, the diverging ramp, not drive. Inferno's five stops (matplotlib, perceptually uniform), kept exactly so the lab's own previews and the app match: black, aubergine, magenta-red, orange, pale yellow. Not scale.activity: the ember means firing, and a stimulus is not a seizure. The engine adds a little emission for this scale (design/tokens.json overlays): a stimulus is light.",
      "kind": "sequential",
      "$value": [
        {
          "position": 0.0,
          "color": "#000004"
        },
        {
          "position": 0.25,
          "color": "#56106E"
        },
        {
          "position": 0.5,
          "color": "#BB3754"
        },
        {
          "position": 0.75,
          "color": "#F98C0A"
        },
        {
          "position": 1.0,
          "color": "#FCFFA4"
        }
      ]
    },
    "occupancy": {
      "$type": "gradient",
      "$description": "Drug concentration and receptor occupancy, none to full. Teal, the one hue family no anatomy system uses at this lightness.",
      "kind": "sequential",
      "$value": [
        {
          "position": 0.0,
          "color": "#0E2328"
        },
        {
          "position": 0.25,
          "color": "#145C62"
        },
        {
          "position": 0.5,
          "color": "#2AA198"
        },
        {
          "position": 0.75,
          "color": "#7FDCC8"
        },
        {
          "position": 1.0,
          "color": "#E6FBF3"
        }
      ]
    },
    "engagement": {
      "$type": "gradient",
      "$description": "Drug target engagement on tissue, occupancy times receptor density, none to full: the same five stops as scale.occupancy, so one hue says 'drug' on the colour bar, the sparklines and the cortex. It differs from occupancy only in the overlay rule: a tint of the lit tissue and never emission (design/tokens.json overlays); the engine drew it through the seizure emission path until tokens 1.3.0.",
      "kind": "sequential",
      "$value": [
        {
          "position": 0.0,
          "color": "#0E2328"
        },
        {
          "position": 0.25,
          "color": "#145C62"
        },
        {
          "position": 0.5,
          "color": "#2AA198"
        },
        {
          "position": 0.75,
          "color": "#7FDCC8"
        },
        {
          "position": 1.0,
          "color": "#E6FBF3"
        }
      ]
    },
    "change": {
      "$type": "gradient",
      "$description": "Signed change from a reference, diverging about zero: the measured drug ΔFC (ba-activity's measured-delta-fc-v1, drug minus baseline in Fisher Δz, 432-node matrices and the fsLR-32k row-strength field), and later any difference map, a signed field component (E·n) or a model minus its measurement. Less is violet, more is orange, and zero is a dark neutral slate, not white: on the dark panels a matrix's near-zero cells sit at the panel and both wings brighten away from zero, the engine's diverging rule (brightness follows the distance from the centre, as its signed flow map does), and on tissue a measured zero is a faint slate (design/tokens.json overlays.change, albedo_floor 0.4), so it differs from a parcel with no data, which keeps the bare tissue. The domain is symmetric, ±h, with h from the data's own range (measured-delta-fc-v1 publishes ±0.226 Δz for the field and ±0.324 Δz for the matrices), never from the viewer; the colour bar labels −h, 0 and +h. Not scale.pressure (blue to red, the vessels' reference pressure) and not the viewport API's coolwarm: a blue end sits within ΔE2000 10 of Drugs' teal (scale.engagement's #2AA198) under tritanopia, the violet keeps 18.5 at worst, and the orange keeps 13.7 from the artery red. The ends match in lightness (L* 64.0 and 65.3) and stay 42 apart under all three simulations; the 0.25 and 0.75 stops are the Oklab midpoints between each end and the centre. design/scripts/cvd_check.py checks every diverging scale: ends 12 apart under each simulation and within 6 L* of each other, a centre with chroma under 10, and each end 12 from the centre.",
      "kind": "diverging",
      "$value": [
        {
          "position": 0.0,
          "color": "#9A8CFF"
        },
        {
          "position": 0.25,
          "color": "#5F5D98"
        },
        {
          "position": 0.5,
          "color": "#2B313C"
        },
        {
          "position": 0.75,
          "color": "#8A5E46"
        },
        {
          "position": 1.0,
          "color": "#E8862E"
        }
      ]
    },
    "trace": {
      "$description": "Time-series traces (EEG, SEEG, pressure and flow curves) drawn in the inspector and the transport bar.",
      "line": {
        "$type": "color",
        "$value": "#DCE4EE"
      },
      "line-dim": {
        "$type": "color",
        "$value": "#5C6675",
        "$description": "Unselected channels."
      },
      "line-highlight": {
        "$type": "color",
        "$value": "#FFFFFF",
        "$description": "The hovered or selected channel."
      },
      "event": {
        "$type": "color",
        "$value": "#FFB347",
        "$description": "Spike and seizure-onset markers."
      },
      "grid": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.06)"
      },
      "playhead": {
        "$type": "color",
        "$value": "#FFFFFF"
      },
      "width": {
        "$type": "dimension",
        "$value": 1.25
      }
    }
  },
  "font": {
    "family": {
      "ui": {
        "$type": "fontFamily",
        "$value": [
          "Inter",
          "Inter Variable",
          "-apple-system",
          "BlinkMacSystemFont",
          "Segoe UI",
          "Helvetica Neue",
          "Arial",
          "sans-serif"
        ],
        "$description": "Inter, bundled as the variable woff2 (SIL OFL-1.1, logged in docs/legal/log/2026-10-01-design-system-v1.md). The engine's native build keeps Roboto until it bundles Inter; the metrics below are close enough that layouts hold."
      },
      "mono": {
        "$type": "fontFamily",
        "$value": [
          "JetBrains Mono",
          "SF Mono",
          "Menlo",
          "Consolas",
          "monospace"
        ],
        "$description": "Ids, coordinates, hashes and code. Bundled as the variable woff2 (SIL OFL-1.1, logged). Changing numbers in prose use Inter with tabular figures, not mono."
      }
    },
    "features": {
      "tabular": {
        "$type": "fontFeature",
        "$value": "\"ss03\" 1, \"tnum\" 1",
        "$description": "font.features.ui-default plus tabular figures (tnum), so numbers keep the UI's features. On every numeric readout, table column and slider value; .ba-type-numeric and .ba-type-numeric-large set it. Change it with ui-default."
      },
      "ui-default": {
        "$type": "fontFeature",
        "$value": "\"ss03\" 1",
        "$description": "Inter's round quotes and commas (ss03) on. cv11, Inter's single-storey a, stays off: at 11–13 px we keep Inter's default double-storey a. Set once on the root."
      }
    },
    "weight": {
      "regular": {
        "$type": "fontWeight",
        "$value": 430
      },
      "medium": {
        "$type": "fontWeight",
        "$value": 530
      },
      "semibold": {
        "$type": "fontWeight",
        "$value": 620
      },
      "$description": "Inter variable, set 30 units heavier than the nominal 400/500/600 because light text on a dark surface reads thin. Named regular/medium/semibold; never other values."
    },
    "files": {
      "$description": "What the app bundles, so every machine renders the same text. Pin the versions in package.json or a fonts README.",
      "inter": {
        "$type": "string",
        "$value": "Inter 4.x variable, InterVariable.woff2, from https://github.com/rsms/inter/releases"
      },
      "jetbrains-mono": {
        "$type": "string",
        "$value": "JetBrains Mono 2.x variable, JetBrainsMono[wght].woff2, from https://github.com/JetBrains/JetBrainsMono/releases"
      }
    }
  },
  "type": {
    "$description": "Every piece of text on screen uses exactly one of these roles. Size and line-height in px; tracking in em.",
    "display": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 24,
        "lineHeight": 28,
        "weight": 620,
        "tracking": -0.02
      },
      "$description": "Scene title in the Methods sheet; the caption title in presentation mode."
    },
    "title": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 18,
        "lineHeight": 24,
        "weight": 620,
        "tracking": -0.012
      },
      "$description": "Inspector title: the selected structure's name."
    },
    "heading": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 15,
        "lineHeight": 20,
        "weight": 620,
        "tracking": -0.006
      },
      "$description": "Panel and sheet section headings."
    },
    "palette-query": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 15,
        "lineHeight": 20,
        "weight": 430,
        "tracking": -0.006
      },
      "$description": "The command palette's input: heading's size at regular weight, so the query reads as typed text."
    },
    "body": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 13,
        "lineHeight": 18,
        "weight": 430,
        "tracking": 0
      },
      "$description": "The default: rows, controls, descriptions, the Methods lines."
    },
    "body-strong": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 13,
        "lineHeight": 18,
        "weight": 530,
        "tracking": 0
      },
      "$description": "Selected rows, button labels, names in a list."
    },
    "small": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 12,
        "lineHeight": 16,
        "weight": 430,
        "tracking": 0.002
      },
      "$description": "Second lines under names; units beside values."
    },
    "caption": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 11,
        "lineHeight": 14,
        "weight": 430,
        "tracking": 0.01
      },
      "$description": "Meta: sources, counts, the engine caption, the Methods sheet's labels."
    },
    "overline": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 11,
        "lineHeight": 14,
        "weight": 620,
        "tracking": 0.06,
        "transform": "uppercase"
      },
      "$description": "Section labels inside panels. The only uppercase text in the app."
    },
    "numeric": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 13,
        "lineHeight": 18,
        "weight": 530,
        "tracking": 0,
        "features": "tabular"
      },
      "$description": "Readouts: time, mm, mmHg, cm/s. Inter with tabular figures."
    },
    "numeric-large": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 18,
        "lineHeight": 24,
        "weight": 530,
        "tracking": -0.01,
        "features": "tabular"
      },
      "$description": "The transport bar's clock."
    },
    "mono": {
      "$type": "typography",
      "$value": {
        "family": "mono",
        "size": 12,
        "lineHeight": 16,
        "weight": 430,
        "tracking": 0
      },
      "$description": "Ids, coordinates, commit hashes."
    },
    "hud-label": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 13,
        "lineHeight": 16,
        "weight": 530,
        "tracking": 0.005
      },
      "$description": "Callout label pills in the canvas."
    },
    "hud-caption": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 11,
        "lineHeight": 14,
        "weight": 430,
        "tracking": 0.01
      },
      "$description": "A callout's second line; the scale bar's value; the time stamp."
    },
    "kbd": {
      "$type": "typography",
      "$value": {
        "family": "ui",
        "size": 11,
        "lineHeight": 14,
        "weight": 530,
        "tracking": 0.02
      },
      "$description": "Keyboard shortcut chips."
    }
  },
  "space": {
    "$description": "4 px base. Layout rhythm is 8 px; 4 and 12 are for inside controls and between a label and its value.",
    "0": {
      "$type": "dimension",
      "$value": 0
    },
    "1": {
      "$type": "dimension",
      "$value": 4
    },
    "2": {
      "$type": "dimension",
      "$value": 8
    },
    "3": {
      "$type": "dimension",
      "$value": 12
    },
    "4": {
      "$type": "dimension",
      "$value": 16
    },
    "5": {
      "$type": "dimension",
      "$value": 20
    },
    "6": {
      "$type": "dimension",
      "$value": 24
    },
    "8": {
      "$type": "dimension",
      "$value": 32
    },
    "10": {
      "$type": "dimension",
      "$value": 40
    },
    "12": {
      "$type": "dimension",
      "$value": 48
    },
    "16": {
      "$type": "dimension",
      "$value": 64
    }
  },
  "size": {
    "control": {
      "$description": "Heights. Every control on one row shares one height.",
      "sm": {
        "$type": "dimension",
        "$value": 24,
        "$description": "Icon buttons inside rows, chips, kbd."
      },
      "md": {
        "$type": "dimension",
        "$value": 28,
        "$description": "Dense rows: layers, lists, inspector fields, segmented controls in panels, icon buttons, default buttons."
      },
      "lg": {
        "$type": "dimension",
        "$value": 32,
        "$description": "Inputs, the search trigger and the scenario tabs' track in the top bar."
      },
      "xl": {
        "$type": "dimension",
        "$value": 40,
        "$description": "Reserved. The timeline's play button is 36 (component.transport.play)."
      }
    },
    "icon": {
      "xs": {
        "$type": "dimension",
        "$value": 12,
        "$description": "The checkbox's check glyph (component.checkbox) and nothing else."
      },
      "sm": {
        "$type": "dimension",
        "$value": 14,
        "$description": "Inside 24 px controls and inline in text."
      },
      "md": {
        "$type": "dimension",
        "$value": 16,
        "$description": "Panels, rows, buttons."
      },
      "lg": {
        "$type": "dimension",
        "$value": 20,
        "$description": "Top bar and transport bar."
      }
    },
    "dot": {
      "$type": "dimension",
      "$value": 6,
      "$description": "The scenario tab's scene dot and the Views rows' radio dot. The scene dot before the left panel's title is size.swatch.sm."
    },
    "topbar": {
      "$type": "dimension",
      "$value": 48,
      "$description": "The floating top bar. 12 px from the window's top and sides."
    },
    "transport": {
      "$type": "dimension",
      "$value": 60,
      "$description": "The timeline bar in the bottom row."
    },
    "statusline": {
      "$type": "dimension",
      "$value": 24,
      "$description": "Retired in 1.0.1: the hover card and the HUD caption carry what the status line did. Kept for the native build."
    },
    "panel": {
      "left": {
        "$type": "dimension",
        "$value": 288
      },
      "inspector": {
        "$type": "dimension",
        "$value": 328
      },
      "sheet": {
        "$type": "dimension",
        "$value": 420,
        "$description": "The Methods sheet's width, opening above the Methods caption (component.popover.offset above its row)."
      },
      "popover": {
        "$type": "dimension",
        "$value": 240
      },
      "padding": {
        "$type": "dimension",
        "$value": 16
      },
      "gap": {
        "$type": "dimension",
        "$value": 12,
        "$description": "The gutter: between the window edge and every floating panel, and between panels."
      }
    },
    "viewport": {
      "min-width": {
        "$type": "dimension",
        "$value": 720,
        "$description": "Below this the left panel collapses to a rail; below 560 the inspector becomes a sheet."
      }
    },
    "safe-margin": {
      "$type": "dimension",
      "$value": 24,
      "$description": "HUD elements keep this far from the viewport's edges and from any panel."
    },
    "hud": {
      "scalebar-min": {
        "$type": "dimension",
        "$value": 80
      },
      "scalebar-max": {
        "$type": "dimension",
        "$value": 200
      },
      "scalebar-height": {
        "$type": "dimension",
        "$value": 6
      },
      "orientation": {
        "$type": "dimension",
        "$value": 64,
        "$description": "The orientation gnomon's circle, bottom right."
      }
    },
    "swatch": {
      "sm": {
        "$type": "dimension",
        "$value": 8,
        "$description": "The scene dot before the left panel's title."
      },
      "md": {
        "$type": "dimension",
        "$value": 9,
        "$description": "Layer rows, inspector part rows and palette rows: the app's layer swatch, at radius.xs."
      },
      "lg": {
        "$type": "dimension",
        "$value": 14
      }
    },
    "slider": {
      "track": {
        "$type": "dimension",
        "$value": 3
      },
      "thumb": {
        "$type": "dimension",
        "$value": 14
      },
      "min-width": {
        "$type": "dimension",
        "$value": 120
      }
    },
    "scrollbar": {
      "$type": "dimension",
      "$value": 6
    },
    "palette": {
      "width": {
        "$type": "dimension",
        "$value": 620
      },
      "top": {
        "$type": "string",
        "$value": "14vh from the window's top"
      },
      "row": {
        "$type": "dimension",
        "$value": 38
      },
      "input": {
        "$type": "dimension",
        "$value": 52
      }
    }
  },
  "radius": {
    "xs": {
      "$type": "dimension",
      "$value": 3,
      "$description": "kbd chips, swatches."
    },
    "sm": {
      "$type": "dimension",
      "$value": 6,
      "$description": "Buttons, inputs, rows, callout pills."
    },
    "md": {
      "$type": "dimension",
      "$value": 10,
      "$description": "Popovers, the Methods sheet, the timeline's inner controls."
    },
    "lg": {
      "$type": "dimension",
      "$value": 14,
      "$description": "Floating panels: the top bar, the two side panels, the timeline, the palette and sheets."
    },
    "pill": {
      "$type": "dimension",
      "$value": 999
    }
  },
  "border-width": {
    "hairline": {
      "$type": "dimension",
      "$value": 1
    },
    "focus": {
      "$type": "dimension",
      "$value": 2
    },
    "focus-offset": {
      "$type": "dimension",
      "$value": 2
    }
  },
  "shadow": {
    "panel": {
      "$type": "shadow",
      "$value": "0 8px 24px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.06)",
      "$description": "Floating panels. The 1 px white ring replaces a border."
    },
    "sheet": {
      "$type": "shadow",
      "$value": "0 16px 48px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.08)"
    },
    "popover": {
      "$type": "shadow",
      "$value": "0 6px 20px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08)"
    },
    "hud": {
      "$type": "shadow",
      "$value": "0 1px 2px rgba(0, 0, 0, 0.5)",
      "$description": "Under callout pills, drawn by the engine as a 1 px offset darkening."
    }
  },
  "blur": {
    "panel": {
      "$type": "dimension",
      "$value": 16,
      "$description": "backdrop-filter blur on translucent surfaces, with saturate(1.1)."
    }
  },
  "opacity": {
    "$description": "Opacities the chrome uses, as fractions of 1: one value per purpose, so the sheet and the app read a token instead of a literal.",
    "disabled": {
      "$type": "number",
      "$value": 0.35,
      "$description": "A disabled control, whole."
    },
    "hidden-row": {
      "$type": "number",
      "$value": 0.45,
      "$description": "A layer row whose visibility is hidden: its name and swatch."
    },
    "tab-dot-rest": {
      "$type": "number",
      "$value": 0.45,
      "$description": "A scenario tab's scene dot at rest; full with a glow when active."
    },
    "gnomon-far-letter": {
      "$type": "number",
      "$value": 0.55,
      "$description": "The gnomon's L, at the far end of the lateral axis."
    },
    "scalebar-rest": {
      "$type": "number",
      "$value": 0.6,
      "$description": "The scale bar at rest; full while the camera moves."
    }
  },
  "motion": {
    "duration": {
      "micro": {
        "$type": "duration",
        "$value": 120,
        "$description": "Hover, press, toggle, tooltip in."
      },
      "state": {
        "$type": "duration",
        "$value": 200,
        "$description": "Selection, row expand, segmented switch, colour changes."
      },
      "panel": {
        "$type": "duration",
        "$value": 320,
        "$description": "Panels and sheets sliding in and out."
      },
      "camera": {
        "$type": "duration",
        "$value": 600,
        "$description": "Camera moves. Same as design/tokens.json camera.transition_ms."
      },
      "explode": {
        "$type": "duration",
        "$value": 800
      },
      "scene": {
        "$type": "duration",
        "$value": 1200,
        "$description": "Switching scenes: the chrome cross-fades while the engine transitions."
      }
    },
    "easing": {
      "standard": {
        "$type": "cubicBezier",
        "$value": [
          0.2,
          0,
          0,
          1
        ],
        "$description": "Everything that enters or changes."
      },
      "exit": {
        "$type": "cubicBezier",
        "$value": [
          0.3,
          0,
          0.8,
          0.15
        ],
        "$description": "Everything that leaves."
      },
      "camera": {
        "$type": "cubicBezier",
        "$value": [
          0.22,
          1,
          0.36,
          1
        ],
        "$description": "The engine's camera curve, from design/tokens.json."
      },
      "linear": {
        "$type": "cubicBezier",
        "$value": [
          0,
          0,
          1,
          1
        ],
        "$description": "Playback, scrubbing, progress."
      }
    },
    "reduced": {
      "$type": "string",
      "$value": "Under prefers-reduced-motion every duration above camera becomes 0 and camera moves cut; playback still plays."
    },
    "hover-delay": {
      "$type": "duration",
      "$value": 80,
      "$description": "Before a hover state or tooltip shows."
    },
    "tooltip-delay": {
      "$type": "duration",
      "$value": 500,
      "$description": "Before a tooltip shows. 500; spec 1.1.2 quoted 450, and the token wins (spec 1.1.3 says 500)."
    }
  },
  "z": {
    "viewport": {
      "$type": "number",
      "$value": 0
    },
    "hud": {
      "$type": "number",
      "$value": 10,
      "$description": "The app's overlay layer over the canvas: callouts, scale bar, orientation gnomon, section edge marks, time stamp. Pointer events pass through except on the gnomon."
    },
    "panel": {
      "$type": "number",
      "$value": 20
    },
    "topbar": {
      "$type": "number",
      "$value": 30
    },
    "popover": {
      "$type": "number",
      "$value": 35
    },
    "sheet": {
      "$type": "number",
      "$value": 40
    },
    "dialog": {
      "$type": "number",
      "$value": 50
    },
    "toast": {
      "$type": "number",
      "$value": 60
    }
  },
  "hud": {
    "$description": "The overlay inside the viewport. Per the viewport API (docs/contracts/viewport-api-v0.md) the engine draws no UI: the app draws these as an HTML/SVG layer over the canvas, placing callouts from the engine's `labels` anchors (x, y, depth, visible area) and projecting its own points with `camera.viewProj`. Values are CSS px. The engine keeps only the hover and selection outlines and the ghost state from design/tokens.json. The native build adopts the same values when it drops egui.",
    "label": {
      "text": {
        "$type": "reference",
        "$value": "{type.hud-label}"
      },
      "secondary": {
        "$type": "reference",
        "$value": "{type.hud-caption}"
      },
      "color": {
        "$type": "color",
        "$value": "#EEF2F7"
      },
      "secondary-color": {
        "$type": "color",
        "$value": "#A7B0BE"
      },
      "background": {
        "$type": "reference",
        "$value": "{color.surface-translucent.hud}"
      },
      "border": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.10)"
      },
      "radius": {
        "$type": "dimension",
        "$value": 6
      },
      "height": {
        "$type": "dimension",
        "$value": 22,
        "$description": "The pill's height; the text centres on it."
      },
      "padding": {
        "$type": "dimension",
        "$value": [
          0,
          9
        ],
        "$description": "Vertical, horizontal."
      },
      "swatch": {
        "$type": "dimension",
        "$value": 7,
        "$description": "A dot of the structure's colour at the left of the pill."
      },
      "max-chars": {
        "$type": "number",
        "$value": 40,
        "$description": "The longest name a pill shows whole. DKT names run to 53 characters, so packs need a short-name field for callouts: a request to the pack lanes, not solved here."
      },
      "selected-border": {
        "$type": "color",
        "$value": "#FFFFFF"
      },
      "selected-fill": {
        "$type": "color",
        "$value": "#FFFFFF",
        "$description": "The selected structure's pill is white, with selected-text; selected-border is its 1 px inset."
      },
      "selected-text": {
        "$type": "reference",
        "$value": "{color.text.inverse}"
      },
      "hover-ring": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.40)",
        "$description": "The hovered pill's 1 px inset ring: white at 40 %, stronger than border.strong (24 %) so it reads over the picture."
      },
      "blur": {
        "$type": "dimension",
        "$value": 8,
        "$description": "The pill's backdrop blur: half blur.panel. A pill is small, and the picture behind it should stay legible as tone."
      }
    },
    "leader": {
      "width": {
        "$type": "dimension",
        "$value": 1
      },
      "color": {
        "$type": "color",
        "$value": "rgba(238, 242, 247, 0.5)",
        "$description": "White at 50 % (spec 1.1.3; 1.1.2 said 42 to 50)."
      },
      "min-length": {
        "$type": "dimension",
        "$value": 12
      },
      "max-length": {
        "$type": "dimension",
        "$value": 120
      },
      "elbow": {
        "$type": "boolean",
        "$value": true
      }
    },
    "anchor": {
      "radius": {
        "$type": "dimension",
        "$value": 2.5
      },
      "ring": {
        "$type": "dimension",
        "$value": 1
      },
      "ring-color": {
        "$type": "color",
        "$value": "rgba(11, 14, 19, 0.8)",
        "$description": "A dark ring round the white anchor dot: the canvas at 80 %, as spec section 10 says, so the dot reads on lit tissue. White until 1.3.0, against the spec."
      }
    },
    "budget": {
      "rest": {
        "$type": "number",
        "$value": 6,
        "$description": "Callouts in a scene's hero view at rest, and in Presentation. Label density Few is 6 everywhere. Fewer, larger labels read as designed; the old 24 read as a diagram."
      },
      "focus": {
        "$type": "number",
        "$value": 12,
        "$description": "With a structure selected or isolated, or with search matches."
      },
      "max": {
        "$type": "number",
        "$value": 24,
        "$description": "Label density Many."
      },
      "min-area-px2": {
        "$type": "number",
        "$value": 900
      },
      "gap": {
        "$type": "dimension",
        "$value": 8
      },
      "fade": {
        "$type": "duration",
        "$value": 150
      }
    },
    "exclusion": {
      "$type": "string",
      "$value": "Every panel, bar and caption rectangle, expanded by size.safe-margin, is a hard exclusion region: no pill, leader or anchor is drawn inside it. The app also sends the same rectangles to the engine as `insets`, so framing and presets fit the clear area."
    },
    "scalebar": {
      "color": {
        "$type": "color",
        "$value": "#EEF2F7"
      },
      "text": {
        "$type": "reference",
        "$value": "{type.hud-caption}"
      },
      "position": {
        "$type": "string",
        "$value": "Bottom right, left of the orientation gnomon, bottom-aligned with it."
      },
      "rule": {
        "$type": "string",
        "$value": "Length snaps to 1, 2 or 5 × 10ⁿ in the scene's unit (mm, µm, nm) at the orbit target's depth, between scalebar-min and scalebar-max px. Always shown while zooming; fades to 60 % at rest."
      }
    },
    "section-edge-mark": {
      "text": {
        "$type": "typography",
        "$value": {
          "family": "ui",
          "size": 12,
          "lineHeight": 12,
          "weight": 620,
          "tracking": 0.02
        }
      },
      "background": {
        "$type": "reference",
        "$value": "{color.surface-translucent.hud}"
      },
      "rule": {
        "$type": "string",
        "$value": "L and R, or A and P, at the slice's edges in the canvas, so a cut face is never shown without its sides named."
      }
    },
    "timestamp": {
      "text": {
        "$type": "reference",
        "$value": "{type.hud-caption}"
      },
      "position": {
        "$type": "string",
        "$value": "Presentation mode only, above the scale bar."
      },
      "rule": {
        "$type": "string",
        "$value": "The scene clock in the scene's unit: m:ss.s, or h:mm after onset for stroke evolution."
      }
    },
    "hover-outline": {
      "$type": "string",
      "$value": "Engine-drawn, unchanged from design/tokens.json states.hover and states.selected: white screen-space outlines, 1.5 px and 2.5 px. The only UI the engine paints."
    },
    "orientation": {
      "$description": "A gnomon, not a cube: three RAS axis lines from the centre of a 64 px circle, letters at their ends. No axis colours: the chrome stays colourless and red already means artery.",
      "background": {
        "$type": "color",
        "$value": "rgba(10, 12, 16, 0.55)"
      },
      "ring": {
        "$type": "reference",
        "$value": "{color.border.hairline}"
      },
      "axis": {
        "$type": "color",
        "$value": "rgba(238, 242, 247, 0.55)"
      },
      "axis-near": {
        "$type": "color",
        "$value": "#EEF2F7",
        "$description": "The axis pointing toward the viewer."
      },
      "letters": {
        "$type": "typography",
        "$value": {
          "family": "ui",
          "size": 10,
          "lineHeight": 10,
          "weight": 620,
          "tracking": 0.02
        },
        "$description": "R, A and S at the positive ends, and L at the far end of the lateral axis at 55 % (P and I would crowd the circle). When the camera looks along an axis, that axis collapses to the facing letter at the centre. The one place 10 px is allowed, because the letters are glyphs, not text."
      },
      "rule": {
        "$type": "string",
        "$value": "Clicking a letter sends the matching camera preset."
      }
    },
    "engine-caption": {
      "$description": "The engine's state line, left of the scale bar: 'Mock viewport', '48 fps', 'Loading 12 of 40'. Hidden in presentation.",
      "text": {
        "$type": "reference",
        "$value": "{type.caption}"
      },
      "color": {
        "$type": "reference",
        "$value": "{color.text.tertiary}",
        "$description": "Tertiary, not disabled: text.disabled vanished over a bright render (the sheet's 1.2 backlog, item 10)."
      },
      "text-shadow": {
        "$type": "reference",
        "$value": "{component.methods.caption.text-shadow}",
        "$description": "The Methods caption's shadow, so the line reads over lit tissue."
      }
    }
  },
  "component": {
    "$description": "Measurements the sheet renders and the app implements. Colours reference the groups above.",
    "button": {
      "height": {
        "$type": "reference",
        "$value": "{size.control.md}"
      },
      "padding-x": {
        "$type": "dimension",
        "$value": 10
      },
      "gap": {
        "$type": "dimension",
        "$value": 6,
        "$description": "Icon to label."
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.sm}"
      },
      "text": {
        "$type": "reference",
        "$value": "{type.small}",
        "$description": "12/16 at weight medium inside 28 px buttons; body-strong in 32 px ones."
      },
      "variants": {
        "primary": {
          "$type": "string",
          "$value": "accent.primary fill, text.inverse. One per view at most."
        },
        "secondary": {
          "$type": "string",
          "$value": "interactive.hover fill, border.medium outline, text.primary. Hover: interactive.pressed fill, border.strong."
        },
        "ghost": {
          "$type": "string",
          "$value": "No fill or border at rest; interactive.hover on hover. For icon buttons and row actions."
        },
        "danger": {
          "$type": "string",
          "$value": "Ghost at rest; feedback.danger text. Reset-to-default and delete actions only."
        }
      },
      "icon-only": {
        "$type": "string",
        "$value": "Square at the control height; always has a tooltip with the name and shortcut."
      },
      "weight": {
        "$type": "reference",
        "$value": "{font.weight.medium}",
        "$description": "Button labels: type.small at medium weight (spec section 12). small's own weight is regular, for second lines; the sheet bridged this with font.weight.medium until 1.3.0."
      },
      "primary-hover": {
        "$type": "color",
        "$value": "#F0F1F1",
        "$description": "The primary button on hover: accent.primary mixed 6 % toward the canvas."
      },
      "primary-pressed": {
        "$type": "color",
        "$value": "#E7E7E7",
        "$description": "The primary button pressed: accent.primary mixed 10 % toward the canvas."
      }
    },
    "segmented": {
      "height": {
        "$type": "reference",
        "$value": "{size.control.md}"
      },
      "padding": {
        "$type": "dimension",
        "$value": 2,
        "$description": "Track inset around the segments."
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.sm}"
      },
      "track": {
        "$type": "reference",
        "$value": "{color.interactive.hover}"
      },
      "active": {
        "$type": "reference",
        "$value": "{color.interactive.selected}"
      },
      "active-text": {
        "$type": "reference",
        "$value": "{type.body-strong}"
      },
      "inactive-text-color": {
        "$type": "reference",
        "$value": "{color.text.secondary}"
      },
      "rule": {
        "$type": "string",
        "$value": "Two to five options, all visible, one always active. md: 26 px segments on a 30 px track; sm: 22 on 26. The track is interactive.hover with a hairline inset; the active segment interactive.selected with a 1 px shadow; inactive text in text.tertiary."
      },
      "md": {
        "$description": "Panels: the default size (segment height = size.control.md - 2).",
        "track": {
          "$type": "dimension",
          "$value": 30
        },
        "segment": {
          "$type": "dimension",
          "$value": 26
        }
      },
      "sm": {
        "$description": "Rows: the visibility control and the timeline's speeds.",
        "track": {
          "$type": "dimension",
          "$value": 26
        },
        "segment": {
          "$type": "dimension",
          "$value": 22
        }
      }
    },
    "toggle": {
      "width": {
        "$type": "dimension",
        "$value": 30
      },
      "height": {
        "$type": "dimension",
        "$value": 18
      },
      "thumb": {
        "$type": "dimension",
        "$value": 14
      },
      "on": {
        "$type": "reference",
        "$value": "{color.accent.primary}"
      },
      "off": {
        "$type": "reference",
        "$value": "{color.border.strong}"
      },
      "rule": {
        "$type": "string",
        "$value": "For one on/off, right-aligned in its row with the label on the left. On: a white track with a dark knob; off: border.medium track with a text.secondary knob."
      }
    },
    "checkbox": {
      "size": {
        "$type": "dimension",
        "$value": 14
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.xs}"
      },
      "rule": {
        "$type": "string",
        "$value": "For lists where several items can be on. The check glyph is Lucide check at 12 px, text.inverse on accent.primary."
      }
    },
    "slider": {
      "track": {
        "$type": "reference",
        "$value": "{size.slider.track}"
      },
      "track-color": {
        "$type": "reference",
        "$value": "{color.border.medium}"
      },
      "fill-color": {
        "$type": "reference",
        "$value": "{color.text.primary}"
      },
      "thumb": {
        "$type": "dimension",
        "$value": 13
      },
      "thumb-color": {
        "$type": "color",
        "$value": "#FFFFFF"
      },
      "value": {
        "$type": "reference",
        "$value": "{type.numeric}",
        "$description": "The current value at the row's right."
      },
      "value-width": {
        "$type": "dimension",
        "$value": 56,
        "$description": "The value column at the right of a slider row."
      },
      "layout": {
        "$type": "string",
        "$value": "In a row: the label (small, secondary, 64 wide) on the left, the track filling the middle, and the current value (numeric, value-width) at the right. Reset to the default by double-clicking the thumb."
      }
    },
    "input": {
      "height": {
        "$type": "reference",
        "$value": "{size.control.lg}"
      },
      "padding-x": {
        "$type": "dimension",
        "$value": 10
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.sm}"
      },
      "background": {
        "$type": "reference",
        "$value": "{color.interactive.hover}"
      },
      "border": {
        "$type": "reference",
        "$value": "{color.border.medium}"
      },
      "placeholder": {
        "$type": "reference",
        "$value": "{color.text.tertiary}"
      }
    },
    "search": {
      "height": {
        "$type": "reference",
        "$value": "{size.control.lg}"
      },
      "width": {
        "$type": "dimension",
        "$value": 220,
        "$description": "The trigger in the top bar. Search itself opens as the command palette (size.palette)."
      },
      "icon": {
        "$type": "string",
        "$value": "search, 16 px, text.tertiary, 10 px from the left edge."
      },
      "kbd": {
        "$type": "string",
        "$value": "⌘K at the right edge at rest; replaced by an × clear button while there is text."
      },
      "results": {
        "row-height": {
          "$type": "reference",
          "$value": "{size.palette.row}"
        },
        "max-rows": {
          "$type": "number",
          "$value": 8
        },
        "group": {
          "$type": "reference",
          "$value": "{type.overline}"
        },
        "layout": {
          "$type": "string",
          "$value": "A centred command palette, 620 wide, 14 vh from the top: a 52 px input row, then grouped results (overline group headings) of 38 px rows: swatch · name (body-strong) with the matched synonym in secondary · path in caption on a second line · side tag right-aligned. Enter selects and frames, Shift+Enter selects in place, Esc closes. While typing, matches are emphasised in the viewport."
        }
      }
    },
    "row": {
      "$description": "List rows: layers, structures, parameters, channels.",
      "height": {
        "$type": "reference",
        "$value": "{size.control.md}"
      },
      "padding-x": {
        "$type": "dimension",
        "$value": 8
      },
      "gap": {
        "$type": "dimension",
        "$value": 8
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.sm}"
      },
      "indent": {
        "$type": "dimension",
        "$value": 16,
        "$description": "Per tree level."
      },
      "columns": {
        "$type": "string",
        "$value": "swatch (9, radius 3) · name (fill, truncates) · count or value (caption, tertiary, right-aligned) · the visibility segmented (sm). Every row in a list has the same columns, even when a cell is empty."
      },
      "hover": {
        "$type": "reference",
        "$value": "{color.interactive.hover}"
      },
      "selected": {
        "$type": "reference",
        "$value": "{color.interactive.selected}"
      },
      "dot-ring": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.35)",
        "$description": "The Views rows' radio dot (size.dot) at rest: a 1 px ring at 35 %; filled white when active."
      }
    },
    "visibility": {
      "$description": "The three-state control on layer rows: a small icon-only segmented (show · ghost · hide) at the row's right.",
      "shown": {
        "$type": "string",
        "$value": "lucide eye"
      },
      "ghost": {
        "$type": "string",
        "$value": "lucide circle-dashed"
      },
      "hidden": {
        "$type": "string",
        "$value": "lucide eye-off"
      },
      "rule": {
        "$type": "string",
        "$value": "Segmented at size sm (22 high, 24 min width), inactive glyphs in text.tertiary, the active on interactive.selected in text.primary. A hidden row's name and swatch drop to 45 %. Clicking the name isolates the group; clicking again clears."
      },
      "height": {
        "$type": "dimension",
        "$value": 22,
        "$description": "The control's height: the sm segmented's segment height (component.segmented.sm.segment), on no track and with no outline."
      },
      "min-width": {
        "$type": "dimension",
        "$value": 24,
        "$description": "Each glyph's cell."
      },
      "inactive-opacity": {
        "$type": "number",
        "$value": 0.7,
        "$description": "The two inactive glyphs: text.tertiary at 70 %."
      }
    },
    "tabs": {
      "height": {
        "$type": "reference",
        "$value": "{size.control.lg}",
        "$description": "The track. Each tab inside it is size.control.md (28)."
      },
      "gap": {
        "$type": "reference",
        "$value": "{component.segmented.padding}",
        "$description": "Between tabs on the track: 2, the same as the track's padding."
      },
      "text": {
        "$type": "reference",
        "$value": "{type.body-strong}"
      },
      "inactive-color": {
        "$type": "reference",
        "$value": "{color.text.secondary}"
      },
      "indicator": {
        "$type": "string",
        "$value": "No underline. The active tab sits on interactive.selected with a 1 px shadow, and its scene dot goes from 45 % to full with a soft glow."
      }
    },
    "panel": {
      "width": {
        "$type": "reference",
        "$value": "{size.panel.left}"
      },
      "padding": {
        "$type": "reference",
        "$value": "{size.panel.padding}"
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.lg}"
      },
      "background": {
        "$type": "reference",
        "$value": "{color.surface-translucent.panel}"
      },
      "shadow": {
        "$type": "reference",
        "$value": "{shadow.panel}"
      },
      "header-height": {
        "$type": "dimension",
        "$value": 40
      },
      "section-head-height": {
        "$type": "dimension",
        "$value": 22,
        "$description": "Each section's overline head row; it may carry one action at the right."
      },
      "section-gap": {
        "$type": "dimension",
        "$value": 16,
        "$description": "Between sections, with a hairline between."
      },
      "rule": {
        "$type": "string",
        "$value": "Floats 12 px under the top bar and 12 px from the side; the bottom ends 12 px above the bottom row. Head: the scene name in title with a 8 px scene dot before it, the tagline in small under it, a hairline below. Sections start with an overline in a 22 px head row, 16 apart with a hairline between. Scrolls inside."
      }
    },
    "inspector": {
      "width": {
        "$type": "reference",
        "$value": "{size.panel.inspector}"
      },
      "title": {
        "$type": "reference",
        "$value": "{type.title}"
      },
      "subtitle": {
        "$type": "reference",
        "$value": "{type.small}"
      },
      "field-label": {
        "$type": "reference",
        "$value": "{type.caption}"
      },
      "field-value": {
        "$type": "reference",
        "$value": "{type.body}"
      },
      "field-gap": {
        "$type": "dimension",
        "$value": 12
      },
      "actions": {
        "$type": "string",
        "$value": "A row of 28 px buttons under the breadcrumbs: Isolate (primary while isolated), Focus, Hide, and the scene's own action. Never more than four."
      },
      "rule": {
        "$type": "string",
        "$value": "Opens on selection, right side, the same top as the left panel. Eyebrow in overline ('Cortex · Left'), then the name in title, close × at the top right; breadcrumbs in caption; the actions row; the description (4 lines + More); parts as swatch rows; a facts grid (64 px labels) with Volume, Area and Data (the origin sentence); then 'How this was made' and 'Source' as collapsed disclosures."
      }
    },
    "methods": {
      "caption": {
        "text": {
          "$type": "reference",
          "$value": "{type.small}"
        },
        "color": {
          "$type": "reference",
          "$value": "{color.text.secondary}"
        },
        "padding-x": {
          "$type": "dimension",
          "$value": 6
        },
        "max-width": {
          "$type": "dimension",
          "$value": 720,
          "$description": "In Explore, where there is no timeline, the caption may span to 720; beside a timeline it keeps the 288 column."
        },
        "position": {
          "$type": "string",
          "$value": "The Methods caption: left column of the bottom row (288 wide; in Explore it may span to max-width), set straight on the picture with no surface: 'Methods' in overline, then the one-line caption in small with the text shadow. One line truncating in Explore; beside a timeline it may wrap once (max-lines). Click, or the Methods button in the bar, opens the sheet above it. Shown in presentation mode and in captures."
        },
        "text-shadow": {
          "$type": "shadow",
          "$value": "0 1px 6px rgba(0, 0, 0, 0.8)"
        },
        "max-lines": {
          "$type": "number",
          "$value": 2
        }
      },
      "caption-row": {
        "$description": "The row the Methods caption sits in on the picture (spec section 8).",
        "height": {
          "$type": "dimension",
          "$value": 40,
          "$description": "The bottom row's height where there is no timeline (Explore): the left panel ends 12 px above it and the Methods sheet opens component.popover.offset above it. Beside a timeline the row is size.transport high."
        },
        "padding": {
          "$type": "dimension",
          "$value": [
            4,
            6
          ],
          "$description": "The caption's box, vertical and horizontal: the inset of its hover fill (interactive.hover at radius.sm). A negative margin of caption.padding-x keeps the text on the 12 px gutter."
        },
        "gap": {
          "$type": "dimension",
          "$value": 8,
          "$description": "From 'Methods' in overline to the line, on one baseline."
        }
      },
      "sheet": {
        "width": {
          "$type": "reference",
          "$value": "{size.panel.sheet}"
        },
        "background": {
          "$type": "reference",
          "$value": "{color.surface-translucent.sheet}"
        },
        "radius": {
          "$type": "reference",
          "$value": "{radius.md}"
        },
        "shadow": {
          "$type": "reference",
          "$value": "{shadow.sheet}"
        },
        "padding": {
          "$type": "dimension",
          "$value": 16
        },
        "label-width": {
          "$type": "dimension",
          "$value": 84,
          "$description": "The definition list's label column."
        },
        "sections": {
          "$type": "string",
          "$value": "The sheet above the caption, 420 wide: heading 'Methods' in body-strong, the one-line text, then a two-column definition list (label-width labels) in this order: Model · Data · Parameters · What is simulated · What is measured · Sources · Renderer. Each one or two lines from metadata; Sources collapses after two. Never a badge, never a warning tone."
        }
      }
    },
    "transport": {
      "height": {
        "$type": "reference",
        "$value": "{size.transport}"
      },
      "padding-x": {
        "$type": "dimension",
        "$value": 14
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.lg}"
      },
      "background": {
        "$type": "reference",
        "$value": "{color.surface-translucent.panel}"
      },
      "play": {
        "$type": "dimension",
        "$value": 36,
        "$description": "Round, white, text.inverse icon."
      },
      "clock": {
        "$type": "reference",
        "$value": "{type.numeric}",
        "$description": "The current time in numeric at semibold weight, stacked over the total in caption text.tertiary."
      },
      "scrub-track": {
        "$type": "dimension",
        "$value": 4
      },
      "scrub-fill": {
        "$type": "string",
        "$value": "The scene's identity colour (color.scene.*)."
      },
      "scrub-track-color": {
        "$type": "reference",
        "$value": "{color.border.medium}"
      },
      "tick": {
        "$type": "dimension",
        "$value": [
          2,
          12
        ],
        "$description": "Event ticks on the track: width, height."
      },
      "event-marker": {
        "$type": "string",
        "$value": "A tick (tick, 2 × 12) in white at 55 % for each of the sim header's scenario.events, its label in caption text.tertiary above: 'Occlusion', 'Thrombectomy'. Clicking a tick jumps to it."
      },
      "layout": {
        "$type": "string",
        "$value": "Columns auto auto 1fr auto, 14 px gaps: skip-back and the round play button; the readout stacked (now in numeric at semibold, the total in caption below); the track (4 px rail, played part in the scene colour, a 14 px white head, event ticks with their labels in caption above); then a loop glyph when periodic and the speed segmented."
      },
      "position": {
        "$type": "string",
        "$value": "The middle column of the bottom row, between the Methods caption and the HUD, on the 12 px gutter."
      },
      "tick-color": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.55)",
        "$description": "Event ticks on the scrub track (tick): white at 55 %."
      }
    },
    "colorbar": {
      "width": {
        "$type": "dimension",
        "$value": 160
      },
      "height": {
        "$type": "dimension",
        "$value": 8
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.xs}"
      },
      "ticks": {
        "$type": "reference",
        "$value": "{type.caption}"
      },
      "rule": {
        "$type": "string",
        "$value": "A horizontal strip of the scale with min and max labelled in the unit, and the quantity's name above in type.small. Lives in the left panel under the layer that uses it, never floating on the viewport."
      }
    },
    "electrode-site": {
      "$description": "A recording site drawn over the picture at its montage position (the sim's forward.json) projected with camera.viewProj, the same size at every zoom: Seizure's EEG 10–20 sites. Callout pills never cover one (spec section 10).",
      "dot": {
        "$type": "dimension",
        "$value": 8,
        "$description": "The disc's diameter."
      },
      "stroke": {
        "$type": "dimension",
        "$value": 1,
        "$description": "The ring round the disc."
      },
      "stroke-color": {
        "$type": "color",
        "$value": "rgba(11, 14, 19, 0.8)",
        "$description": "The canvas colour at 80 %, so a site reads on lit and unlit tissue alike."
      },
      "rest": {
        "$type": "color",
        "$value": "#D9C9B4",
        "$description": "A site over quiet cortex: colour script 4's ivory, the cells' tissue colour."
      },
      "active": {
        "$type": "color",
        "$value": "#FFB347",
        "$description": "A site over seizing cortex: the ictal amber, the activity scale's 0.75 stop (scale.activity) and scale.trace.event."
      },
      "rest-below": {
        "$type": "number",
        "$value": 0.3,
        "$description": "The activity under the site (0 to 1 on the activity scale) below which it is at rest."
      },
      "active-above": {
        "$type": "number",
        "$value": 0.6,
        "$description": "Above this the site is fully active. Between rest-below and active-above the disc mixes from rest to active and the halo fades in, on a smoothstep."
      },
      "halo": {
        "$type": "dimension",
        "$value": 24,
        "$description": "The bloom's diameter round an active site: the active colour at halo-opacity in the centre, falling to nothing at the edge, added to the picture (plus-lighter)."
      },
      "halo-opacity": {
        "$type": "number",
        "$value": 0.55,
        "$description": "The halo's centre at full activity; it scales with the mix."
      },
      "clearance": {
        "$type": "dimension",
        "$value": 2,
        "$description": "No callout pill comes nearer a site's disc than this."
      }
    },
    "chip": {
      "height": {
        "$type": "reference",
        "$value": "{size.control.sm}"
      },
      "padding-x": {
        "$type": "dimension",
        "$value": 8
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.pill}"
      },
      "background": {
        "$type": "reference",
        "$value": "{color.interactive.hover}"
      },
      "text": {
        "$type": "reference",
        "$value": "{type.small}"
      },
      "rule": {
        "$type": "string",
        "$value": "A removable filter or an active mode ('Isolated: Left MCA ×'). Never a status badge."
      }
    },
    "kbd": {
      "height": {
        "$type": "dimension",
        "$value": 18
      },
      "padding-x": {
        "$type": "dimension",
        "$value": 5
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.xs}"
      },
      "background": {
        "$type": "reference",
        "$value": "{color.interactive.hover}"
      },
      "border": {
        "$type": "reference",
        "$value": "{color.border.medium}"
      },
      "text": {
        "$type": "reference",
        "$value": "{type.kbd}"
      },
      "rule": {
        "$type": "string",
        "$value": "In tooltips and menus, right-aligned after the label. Never in a paragraph on the screen."
      }
    },
    "tooltip": {
      "padding": {
        "$type": "dimension",
        "$value": [
          6,
          10
        ]
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.sm}"
      },
      "background": {
        "$type": "reference",
        "$value": "{color.surface.3}"
      },
      "text": {
        "$type": "reference",
        "$value": "{type.small}"
      },
      "max-width": {
        "$type": "dimension",
        "$value": 240
      },
      "offset": {
        "$type": "dimension",
        "$value": 6
      },
      "weight": {
        "$type": "reference",
        "$value": "{font.weight.medium}",
        "$description": "Tooltip text: type.small at medium weight (spec section 12)."
      }
    },
    "popover": {
      "offset": {
        "$type": "dimension",
        "$value": 10,
        "$description": "From the popover's anchor."
      }
    },
    "menu": {
      "$description": "Menu rows inside a popover: the Occlusion and Drug selects, the bar's overflow.",
      "height": {
        "$type": "reference",
        "$value": "{size.control.md}"
      },
      "padding-x": {
        "$type": "dimension",
        "$value": 8
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.sm}"
      },
      "text": {
        "$type": "reference",
        "$value": "{type.body}"
      },
      "hover": {
        "$type": "reference",
        "$value": "{color.interactive.hover}"
      },
      "selected": {
        "$type": "reference",
        "$value": "{color.interactive.selected}"
      },
      "rule": {
        "$type": "string",
        "$value": "Rows at size.control.md with 8 px side padding, radius.sm, inside a popover (component.popover): the pointed row on interactive.hover, the current value on interactive.selected with a check at its right; up and down move, Enter picks, Esc closes."
      }
    },
    "toast": {
      "width": {
        "$type": "dimension",
        "$value": 320
      },
      "padding": {
        "$type": "dimension",
        "$value": 12
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.md}"
      },
      "background": {
        "$type": "reference",
        "$value": "{color.surface.3}"
      },
      "duration": {
        "$type": "duration",
        "$value": 4000
      },
      "position": {
        "$type": "string",
        "$value": "Top centre under the top bar. One at a time. For 'Capture saved' and load errors only."
      }
    },
    "dialog": {
      "width": {
        "$type": "dimension",
        "$value": 440
      },
      "padding": {
        "$type": "dimension",
        "$value": 24
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.lg}"
      },
      "background": {
        "$type": "reference",
        "$value": "{color.surface.2}"
      },
      "rule": {
        "$type": "string",
        "$value": "Rare: open a dataset, confirm a reset. Title, one paragraph, two buttons right-aligned, primary last."
      }
    },
    "scene-switcher": {
      "rule": {
        "$type": "string",
        "$value": "Scenario tabs in the top bar's centre: one segmented group on a 2 px-padded track at size.control.lg, each tab 28 high with a 6 px scene dot (45 % at rest, full with a soft glow when active) and the name in body-strong; the active tab on interactive.selected with a 1 px shadow. Keys 1–6."
      },
      "items": {
        "$type": "string",
        "$value": "Explore · Blood flow · Stroke · Seizure · Neurons · Drugs"
      }
    },
    "topbar": {
      "height": {
        "$type": "reference",
        "$value": "{size.topbar}"
      },
      "padding-x": {
        "$type": "dimension",
        "$value": 14
      },
      "background": {
        "$type": "reference",
        "$value": "{color.surface-translucent.panel}"
      },
      "layout": {
        "$type": "string",
        "$value": "Three columns, 1fr auto 1fr: the wordmark (20 px mark + 'Brain Atlas' in heading) left; the scenario tabs centred; on the right a 220 × 32 search trigger ('Search' with a ⌘ K kbd), a quiet Methods button, then 32 px icon buttons with 20 px glyphs for Presentation (P), Capture (C) and Keyboard shortcuts (?). Floats 12 px from the window edges, radius 14, glass."
      },
      "radius": {
        "$type": "reference",
        "$value": "{radius.lg}"
      }
    },
    "statusline": {
      "height": {
        "$type": "reference",
        "$value": "{size.statusline}"
      },
      "text": {
        "$type": "reference",
        "$value": "{type.caption}"
      },
      "layout": {
        "$type": "string",
        "$value": "Retired in the web app (1.0.1): the hover card names what is under the pointer and the HUD caption carries the engine state. Coordinates come to the HUD caption in a later version."
      }
    },
    "empty-state": {
      "rule": {
        "$type": "string",
        "$value": "Centred in the panel: one line of body in text.secondary and, if there is one, a single secondary button. No illustration."
      }
    },
    "loading": {
      "rule": {
        "$type": "string",
        "$value": "A 2 px progress line in accent.primary at the top of the viewport while a pack or run streams, with the count in the status line. No spinner over the render."
      }
    },
    "hover-card": {
      "$description": "A small card that follows the pointer over the viewport, naming what is under it. Replaces the status line's hover readout.",
      "padding": {
        "$type": "dimension",
        "$value": [
          6,
          10
        ]
      },
      "radius": {
        "$type": "dimension",
        "$value": 8
      },
      "offset": {
        "$type": "dimension",
        "$value": [
          14,
          18
        ],
        "$description": "Right and below the pointer."
      },
      "name": {
        "$type": "reference",
        "$value": "{type.small}"
      },
      "meta": {
        "$type": "reference",
        "$value": "{type.caption}"
      },
      "rule": {
        "$type": "string",
        "$value": "Name in small at weight semibold, then 'System · Side' in caption tertiary. Fades in over motion.micro; never shows while dragging."
      }
    },
    "presentation": {
      "rule": {
        "$type": "string",
        "$value": "Key P or the tab-bar button: the top bar, both panels and the timeline slide out over motion.panel; the Methods caption and the HUD stay; insets go to zero. Any click on chrome or Esc restores. Capture in presentation mode is how hero stills come from the app."
      }
    }
  },
  "icon": {
    "set": {
      "$type": "string",
      "$value": "Lucide (ISC), lucide-react, current release pinned in package.json."
    },
    "stroke": {
      "$type": "dimension",
      "$value": 1.5
    },
    "size": {
      "$type": "reference",
      "$value": "{size.icon.md}",
      "$description": "The default glyph; size.icon.sm in 24 px controls, size.icon.lg in the bars."
    },
    "color": {
      "$type": "string",
      "$value": "currentColor; icons never carry a colour of their own."
    },
    "names": {
      "$description": "Semantic name → Lucide icon (file names at the pinned tag). Use these and no others for these meanings. flip is the glyph lucide-react still exports as the deprecated alias FlipHorizontal; its file is square-centerline-dashed-horizontal. checkbox and wordmark joined in 1.2.0; the fetch script carried them outside the map before.",
      "search": "search",
      "methods": "book-open",
      "view": "sliders-horizontal",
      "presentation": "presentation",
      "shortcuts": "keyboard",
      "capture": "camera",
      "close": "x",
      "back": "chevron-left",
      "forward": "chevron-right",
      "expand": "chevron-down",
      "collapse": "chevron-up",
      "more": "ellipsis",
      "play": "play",
      "pause": "pause",
      "skip-back": "skip-back",
      "skip-forward": "skip-forward",
      "loop": "repeat",
      "speed": "gauge",
      "time": "clock",
      "layers": "layers",
      "shown": "eye",
      "ghost": "circle-dashed",
      "hidden": "eye-off",
      "isolate": "focus",
      "solo": "target",
      "show-all": "eye",
      "focus-camera": "scan",
      "section": "scissors",
      "flip": "square-centerline-dashed-horizontal",
      "measure": "ruler",
      "explode": "expand",
      "orientation": "axis-3d",
      "reset-view": "rotate-ccw",
      "undo": "undo-2",
      "redo": "redo-2",
      "pin": "pin",
      "info": "info",
      "warning": "triangle-alert",
      "settings": "settings-2",
      "fullscreen": "maximize",
      "download": "download",
      "copy": "copy",
      "link": "link",
      "scene-explore": "compass",
      "scene-flow": "droplets",
      "scene-stroke": "heart-crack",
      "scene-seizure": "activity",
      "scene-neurons": "brain-circuit",
      "scene-drugs": "pill",
      "occlude": "circle-slash",
      "reopen": "redo-2",
      "stimulate": "zap",
      "record": "circle-dot",
      "dose": "syringe",
      "checkbox": "check",
      "wordmark": "brain"
    }
  },
  "copy": {
    "$description": "Words the app uses. Strings are in English, sentence case.",
    "wordmark": {
      "$type": "string",
      "$value": "Brain Atlas"
    },
    "methods": {
      "$type": "string",
      "$value": "Methods"
    },
    "scenes": {
      "$type": "string",
      "$value": {
        "explore": "Explore",
        "flow": "Blood flow",
        "stroke": "Stroke",
        "seizure": "Seizure",
        "neurons": "Neurons",
        "drugs": "Drugs"
      }
    },
    "side": {
      "$type": "string",
      "$value": {
        "L": "Left",
        "R": "Right",
        "midline": "Midline",
        "bilateral": "Both sides"
      },
      "$description": "Spelled out in names and subtitles. 'L' and 'R' alone only in the right-aligned side tag of a dense row and on section edge marks."
    },
    "units": {
      "$type": "string",
      "$value": "A thin space (U+2009) between number and unit: 12 mm, 3.5 s, 120 mmHg, 45 cm/s, 60 mL/100 g/min. Minus is U+2212."
    },
    "time": {
      "$type": "string",
      "$value": "Scene clocks: m:ss.s under ten minutes; h:mm above. Stroke evolution shows 'h:mm after onset'."
    },
    "banned": {
      "$type": "string",
      "$value": "Research use only · Not for clinical use · any confidence or provenance word as a badge · exclamation marks · title case in labels · ellipses in button labels."
    }
  }
} as const;

/** Structure colours, copied from design/tokens.json systems (the render look owns them). */
export const anatomy = {
  "cortex": "#CCB7AD",
  "white-matter": "#F8F0E3",
  "subcortical": "#9F6DBF",
  "brainstem": "#88673C",
  "cerebellum": "#8EA9BD",
  "ventricle": "#8BE5F5",
  "tract": "#56D5B9",
  "artery": "#E63B3B",
  "vein": "#5091F0",
  "sinus": "#4266B3",
  "cranial-nerve": "#FCD444",
  "lymphatic": "#62B77C",
  "meninges": "#8193A1",
  "skull": "#E0D0AC",
  "scalp": "#BC927C"
} as const;

export type Tokens = typeof tokens;

/** The CSS custom property for a token path: cssVar('color.surface.1') -> 'var(--ba-color-surface-1)'. */
export const cssVar = (path: string): string => `var(--ba-${path.replace(/\./g, '-')})`;
